// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"a13e6174","496":"162d0500"}[chunkId] + ".chunk.js";
};